// This file exists for legacy reasons, do not use the properties defined
// herein.

import * as Platform from '../../../Platform';
import { Signage } from '../../../Signage';

/**
 * Do not use the properties defined herein.  These exist only for legacy
 * reasons.
 */
export function definePlatformVariables(): void {
    if (!window.REACH) {
        window.REACH = {};
    }

    Object.defineProperty(window, 'PLATFORM_UNKNOWN', {
        get: function () {
            console.warn('`PLATFORM_UNKNOWN` is deprecated, use `Platform.UNKNOWN` instead');
            return Platform.UNKNOWN;
        },
    });
    Object.defineProperty(window, 'PLATFORM_REACH_PLAYER', {
        get: function () {
            console.warn(
                '`PLATFORM_REACH_PLAYER` is deprecated, use `Platform.REACH_PLAYER` instead'
            );
            return Platform.REACH_PLAYER;
        },
    });
    Object.defineProperty(window, 'PLATFORM_BRIGHTSIGN', {
        get: function () {
            console.warn('`PLATFORM_BRIGHTSIGN` is deprecated, use `Platform.BRIGHTSIGN` instead');
            return Platform.BRIGHTSIGN;
        },
    });

    Object.defineProperty(window.REACH, 'Platform', {
        get: function () {
            console.warn('`REACH.Platform` is deprecated, use `Signage.platform.isType` instead');
            return Signage.platform.type;
        },
    });
}
